// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-table-row__column--actions.with-actions-buttons{padding-top:12px !important}", "",{"version":3,"sources":["webpack://./jsapp/js/components/assetsTable/assetTableRow.scss"],"names":[],"mappings":"AACE,wDACE,2BAAA","sourcesContent":[".assets-table-row__column--actions {\n  &.with-actions-buttons {\n    padding-top: 12px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
